import React from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@salesforce/retail-react-app/app/components/shared/ui'

import PDComponent from '../../pd-component'

export const PromoGridTwoColumns = ({regions, typeId, name}) => {
    const analyticsProps = {
        componentType: typeId,
        componentName: name || typeId
    }
    return (
        <Grid
            templateColumns={{base: '1fr', lg: '1fr 1fr'}}
            gridTemplateRows={{base: 'repeat(2, 1fr)', lg: '1fr'}}
            aspectRatio={{lg: '1920 / 540'}}
            gap="10px"
            sx={{
                '& > div': {
                    minWidth: 0
                }
            }}
        >
            {regions?.map((region) =>
                region?.components?.map((component, index) => (
                    <PDComponent
                        key={`${region.id}-${index}`}
                        component={component}
                        variant="promoGridTwoItems"
                        analyticsProps={analyticsProps}
                    />
                ))
            )}
        </Grid>
    )
}

PromoGridTwoColumns.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        question: PropTypes.string,
                        answer: PropTypes.string
                    })
                })
            )
        })
    ).isRequired,
    typeId: PropTypes.string,
    name: PropTypes.string
}

export default PromoGridTwoColumns
